import React from 'react';
import Extra from './Extra/Extra';

const ForTeachers = () => {
  return (
    <Extra />
  );
};

export default ForTeachers;



// WEBPACK FOOTER //
// ./src/components/ForTeachers/ForTeachers.js